export const AUTH_COOKIE_NAMES = [
  'access_token',
  'user',
  'temp_token',
  'verification-token',
] as const;

export function decodeJWT(token: string) {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

export function isTokenExpired(token: string): boolean {
  const decoded = decodeJWT(token);
  if (!decoded || !decoded.exp) {
    return true;
  }

  const currentTime = Math.floor(Date.now() / 1000);
  return decoded.exp < currentTime;
}

export function isTokenInvalid(token: string | null | undefined): boolean {
  if (!token || token.trim() === '') {
    return true;
  }

  if (token.split('.').length !== 3) {
    return true;
  }

  return isTokenExpired(token);
}

export function isInvalidTokenMessage(message: string): boolean {
  const normalized = message.toLowerCase();
  return (
    normalized.includes('invalid token') ||
    normalized.includes('token expired') ||
    normalized.includes('token has expired') ||
    normalized.includes('jwt') ||
    normalized.includes('not authenticated') ||
    normalized.includes('unauthorized') ||
    normalized.includes('authentication failed')
  );
}
